module.exports = __webpack_public_path__ + "img/tishitanhchuang.0112d065.png";